import React from 'react';
import AsyncMode from './async';
import Default from './default';

const ReactSelect = {
  AsyncMode: React.memo(AsyncMode),
  Default: React.memo(Default),
};

export default ReactSelect;
